(function () {
  /* Panier Végélia : le pack est vendu comme UNE seule ligne au prix réel du produit (aucun article ajouté en plus). */
  var C = window.VgGiftsConfig;
  if (!C) return;
  C.machine = C.machine || [];
  C.promoCode = C.promoCode || 'BIENVENUE10';
  C.freeShip = C.freeShip || 5000;
  var root = C.root || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var cleaning = false, timer = null, rtimer = null;
  var state = { promoOpen: false, msg: '', msgType: '', typed: '', busy: false };
  try {
    var saved = JSON.parse(sessionStorage.getItem('vgPromoMsg') || 'null');
    if (saved) { state.msg = saved.m; state.msgType = saved.t; state.promoOpen = true; sessionStorage.removeItem('vgPromoMsg'); }
  } catch (e) {}

  function req(path, body) {
    return fetch(root + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || (j && j.status && j.status >= 400)) {
          var e = new Error((j && (j.description || j.message)) || 'Une erreur est survenue. Veuillez réessayer.');
          e.data = j;
          throw e;
        }
        return j;
      });
    });
  }
  function drawer() { return document.querySelector('cart-drawer'); }
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }
  function sectionIds() {
    var d = drawer();
    return d && typeof d.getSectionsToRender === 'function' ? d.getSectionsToRender().map(function (s) { return s.id; }) : [];
  }
  function withSections(body) {
    var ids = sectionIds();
    if (ids.length && !onCartPage()) { body.sections = ids; body.sections_url = location.pathname; }
    return body;
  }
  function refresh(res, open, variantId) {
    if (onCartPage()) { location.reload(); return; }
    var d = drawer();
    if (!d || !res || !res.sections) { render(); return; }
    if (open && typeof d.renderContents === 'function') {
      d.renderContents(Object.assign({}, res, { id: variantId }));
      d.classList.remove('is-empty');
      render();
      return;
    }
    d.getSectionsToRender().forEach(function (s) {
      var html = res.sections[s.id];
      if (!html) return;
      var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (!el) return;
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector || '.shopify-section');
      if (src) el.innerHTML = src.innerHTML;
    });
    if (typeof res.item_count === 'number') d.classList.toggle('is-empty', res.item_count === 0);
    render();
  }
  /* Ajout au panier : uniquement le produit choisi, au prix Shopify. */
  function add(variantId, qty, opts) {
    opts = opts || {};
    qty = Math.max(1, parseInt(qty, 10) || 1);
    var body = { items: [{ id: Number(variantId), quantity: qty }] };
    if (opts.sections !== false) withSections(body);
    return req('cart/add.js', body);
  }
  /* Nettoyage : retire les anciennes lignes « cadeau » ajoutées par l'ancienne version du pack. */
  function isOldGiftLine(it) { return !!(it.properties && it.properties[C.label || 'Offert']); }
  function sync() {
    if (cleaning) return Promise.resolve();
    return req('cart.js').then(function (cart) {
      var updates = {}, n = 0;
      cart.items.forEach(function (it) { if (isOldGiftLine(it)) { updates[it.key] = 0; n++; } });
      if (!n) { render(cart); return null; }
      cleaning = true;
      return req('cart/update.js', withSections({ updates: updates })).then(function (res) {
        cleaning = false;
        refresh(res, false);
      }, function () { cleaning = false; });
    }).catch(function () {});
  }

  /* ---------- Outils ---------- */
  function money(cents, cur) {
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cur || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function part(name) {
    var tpl = document.getElementById('vgc-cart-tpl');
    if (!tpl) return null;
    var el = tpl.content.querySelector('[data-vgc-part="' + name + '"]');
    return el ? el.cloneNode(true) : null;
  }
  function shipText(cart) {
    return cart && cart.total_price >= C.freeShip ? 'Livraison offerte en France' : 'Livraison offerte en France dès ' + money(C.freeShip, cart && cart.currency).replace(',00', '');
  }

  /* ---------- Ligne « Réduction » (code promo) ---------- */
  function reducHtml(cart) {
    var codes = (cart && cart.discount_codes) || [];
    var applied = codes.filter(function (c) { return c.applicable; });
    var h = '<div class="vgc-reduc">' +
      '<button type="button" class="vgc-reduc__head" aria-expanded="' + state.promoOpen + '">' +
      '<span>Réduction</span><span class="vgc-reduc__plus" aria-hidden="true"></span>' +
      '<span class="visually-hidden">Saisir un code promo</span></button>' +
      '<div class="vgc-reduc__body"' + (state.promoOpen ? '' : ' hidden') + '>' +
      '<form class="vgc-reduc__form" novalidate>' +
      '<input class="vgc-reduc__input" name="vgccode" type="text" placeholder="Code promo" aria-label="Code promo" autocomplete="off" autocapitalize="characters" spellcheck="false" value="' + esc(state.typed) + '">' +
      '<button type="submit" class="vgc-reduc__apply"' + (state.busy ? ' disabled' : '') + '>' + (state.busy ? '…' : 'Appliquer') + '</button>' +
      '</form></div>';
    if (applied.length) {
      h += '<ul class="vgc-reduc__codes" role="list">' + applied.map(function (c) {
        return '<li><span>✓ <strong>' + esc(c.code.toUpperCase()) + '</strong> appliqué</span><button type="button" class="vgc-reduc__remove">Retirer</button></li>';
      }).join('') + '</ul>';
    }
    if (state.msg) h += '<p class="vgc-reduc__msg vgc-reduc__msg--' + state.msgType + '" role="status">' + esc(state.msg) + '</p>';
    return h + '</div>';
  }
  function setMsg(m, t) {
    state.msg = m; state.msgType = t;
    if (onCartPage()) { try { sessionStorage.setItem('vgPromoMsg', JSON.stringify({ m: m, t: t })); } catch (e) {} }
  }
  function redraw() { document.querySelectorAll('.vgc-reduc').forEach(function (el) { el.remove(); }); decorate(); }
  function applyCode(raw) {
    var code = String(raw || '').trim().toUpperCase();
    if (!code) { setMsg('Saisissez votre code promo.', 'err'); redraw(); return; }
    state.busy = true; state.typed = code; redraw();
    req('cart/update.js', withSections({ discount: code })).then(function (res) {
      state.busy = false;
      if (!res || !res.discount_codes) {
        location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(location.pathname);
        return;
      }
      var f = res.discount_codes.filter(function (c) { return String(c.code).toUpperCase() === code; })[0];
      if (f && f.applicable) {
        state.typed = '';
        setMsg('Code valide : la réduction est déduite du total.', 'ok');
        lastCart = res;
        refresh(res, false);
      } else {
        setMsg('Code invalide ou non applicable à votre panier.', 'err');
        req('cart/update.js', withSections({ discount: '' })).then(function (r2) { lastCart = r2; refresh(r2, false); }, function () { redraw(); });
      }
    }).catch(function () {
      state.busy = false;
      setMsg('Impossible d\'appliquer le code pour le moment. Vous pourrez le saisir à l\'étape du paiement.', 'err');
      redraw();
    });
  }
  function removeCode() {
    req('cart/update.js', withSections({ discount: '' })).then(function (res) {
      setMsg('', ''); lastCart = res; refresh(res, false);
    }).catch(function () {});
  }

  /* ---------- Placement ---------- */
  function insertEl(parent, before, el) { if (parent && el) parent.insertBefore(el, before || null); }
  function insertHtml(parent, before, html) {
    var w = document.createElement('div');
    w.innerHTML = html;
    insertEl(parent, before, w.firstElementChild);
  }
  function ticker(cart) {
    var el = part('ticker');
    if (el) el.querySelectorAll('[data-vgc-ship]').forEach(function (s) { s.textContent = shipText(cart); });
    return el;
  }
  var ALL = '.vgc-tick,.vgc-reduc,.vgc-rate,.vgc-offer,.vgc-pay';
  function decorate() {
    var cart = lastCart;
    var has = cart && cart.item_count > 0;
    var d = drawer();
    /* Le tiroir Végélia (snippets/cart-drawer.liquid) a sa propre mise en page : on ne le décore plus. */
    if (d && !d.querySelector('.vgd')) {
      if (!has) { d.querySelectorAll(ALL).forEach(function (el) { el.remove(); }); }
      else {
        var head = d.querySelector('.drawer__header');
        if (head && !d.querySelector('.vgc-tick')) insertEl(head.parentNode, head.nextSibling, ticker(cart));
        var foot = d.querySelector('.drawer__footer');
        if (foot) {
          var tot = foot.querySelector('.cart-drawer__footer');
          var ctas = foot.querySelector('.cart__ctas');
          if (!foot.querySelector('.vgc-reduc')) insertHtml(foot, tot, reducHtml(cart));
          if (!foot.querySelector('.vgc-rate')) insertEl(foot, ctas, part('rating'));
          if (!foot.querySelector('.vgc-offer')) insertEl(foot, ctas, part('offer'));
          if (!foot.querySelector('.vgc-pay')) insertEl(foot, null, part('pay'));
        }
      }
    }
    if (onCartPage()) {
      var ci = document.querySelector('cart-items:not(cart-drawer-items)');
      var blocks = document.querySelector('#main-cart-footer .cart__blocks');
      if (!has) {
        if (ci) ci.querySelectorAll('.vgc-tick').forEach(function (el) { el.remove(); });
        if (blocks) blocks.querySelectorAll(ALL).forEach(function (el) { el.remove(); });
      } else {
        var tw = ci && ci.querySelector('.title-wrapper-with-link');
        if (tw && !ci.querySelector('.vgc-tick')) insertEl(tw.parentNode, tw.nextSibling, ticker(cart));
        if (blocks) {
          var pctas = blocks.querySelector('.cart__ctas');
          if (!blocks.querySelector('.vgc-reduc')) insertHtml(blocks, blocks.querySelector('.js-contents') || blocks.firstElementChild, reducHtml(cart));
          if (!blocks.querySelector('.vgc-rate')) insertEl(blocks, pctas, part('rating'));
          if (!blocks.querySelector('.vgc-offer')) insertEl(blocks, pctas, part('offer'));
          if (!blocks.querySelector('.vgc-pay')) insertEl(blocks, document.getElementById('cart-errors'), part('pay'));
        }
      }
    }
  }
  var lastCart = null;
  function place(cart) {
    lastCart = cart;
    var inp = document.querySelector('.vgc-reduc__input');
    if (inp && document.activeElement === inp) return;
    if (inp) state.typed = inp.value;
    document.querySelectorAll('.vgc-tick,.vgc-reduc').forEach(function (el) { el.remove(); });
    decorate();
  }
  function render(cart) {
    if (cart) { place(cart); return; }
    clearTimeout(rtimer);
    rtimer = setTimeout(function () { req('cart.js').then(place).catch(function () {}); }, 120);
  }
  var pending = false;
  function watch() {
    if (!window.MutationObserver) return;
    new MutationObserver(function () {
      if (pending || !lastCart) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; decorate(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  function events() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      var head = t.closest && t.closest('.vgc-reduc__head');
      if (head) {
        e.preventDefault();
        state.promoOpen = !state.promoOpen;
        document.querySelectorAll('.vgc-reduc').forEach(function (p) {
          var b = p.querySelector('.vgc-reduc__body');
          if (b) b.hidden = !state.promoOpen;
          var h = p.querySelector('.vgc-reduc__head');
          if (h) h.setAttribute('aria-expanded', state.promoOpen);
        });
        if (state.promoOpen) { var i = head.parentNode.querySelector('.vgc-reduc__input'); if (i) i.focus(); }
        return;
      }
      if (t.closest && t.closest('.vgc-reduc__remove')) { e.preventDefault(); removeCode(); }
    });
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f.classList || !f.classList.contains('vgc-reduc__form')) return;
      e.preventDefault();
      if (state.busy) return;
      applyCode(f.querySelector('.vgc-reduc__input').value);
    });
  }

  window.VgGifts = { add: add, sync: sync, refresh: refresh, render: render };
  function init() {
    events();
    sync();
    watch();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        clearTimeout(timer);
        timer = setTimeout(sync, 300);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
